import "./index.less";
import template from "./index.html";

function controller() {}

export default angular
	.module("vesl.screens.public.deletion", [])
	.component("deletion", {
		template,
		controller
	}).name;
